import { useEffect, useState } from 'react';

import getFeatureFlags, { type FeatureFlagName } from 'helpers/getFeatureFlags';

export function useFeatureFlag<CoerceToBoolean extends boolean = true>(
  flag: FeatureFlagName,
  coerceToBoolean: CoerceToBoolean = true as CoerceToBoolean,
): CoerceToBoolean extends true ? boolean : boolean | null {
  const [featureFlag, setFeatureFlag] = useState<boolean | null>(coerceToBoolean ? false : null);

  useEffect(() => {
    const loadFeatureFlag = async () => {
      const value = (await getFeatureFlags())[flag] ?? false;
      setFeatureFlag(coerceToBoolean ? value : (value ?? null));
    };

    void loadFeatureFlag();
  }, [flag, coerceToBoolean]);

  return featureFlag as CoerceToBoolean extends true ? boolean : boolean | null;
}
